<template>
    <div>
        <div class="privacy-body">
            <h2>Polityka prywatności</h2>
            <div v-html="privacy" v-if="privacy">

            </div>
            <div v-else>
                <span>Ładowanie...</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
export default{
    name:"PrivacyVue",
    setup () {
    useMeta({
      title: 'Strona główna',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    })
  },
    data(){
        return{
            privacy: ''
        }
    },
    props:{

    },
    mounted(){
        this.getStatuteData()
    },
    methods:{
        getStatuteData(){
            window.scrollTo(0,0)
            axios.get(`${process.env.VUE_APP_API_BASE_URL}CmsAll`)
                .then(res => {
                    this.privacy = res.data[1].content;
                })
        }
    }  
}
</script>

<style scoped>
.privacy-body{
    width: 90%;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    box-sizing: border-box;
    min-height: 500px;
}
</style>